import React, { useEffect, useState } from "react";
import { Form, Input, Button, Drawer, Typography, notification } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import Axios from "axios";
import { Tokens } from "Shared/Tokens";

const { Title, Text } = Typography;

const AddBinance = (props) => {
    const { showConnectBinanceDrawer, onClose, getAssetInfo } = props;
    const [form] = Form.useForm();
    const [disabled, setDisabled] = useState(true);
    const [isMobile, setIsMobile] = useState(
        typeof window !== "undefined" ? window.innerWidth < 768 : false
    );

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const handleValueChange = (value, allValues) => {
        const current = allValues || value || {};
        setDisabled(!current.apiKey || !current.apiSecret);
    };

    const onFinish = async (values) => {
        try {
            const api = `${process.env.REACT_APP_API}/binance/auth/connect`;
            await Axios.post(api, values, {
                withCredentials: true,
            });
            getAssetInfo();
            onClose();
        } catch (error) {
            notification.error({
                message: `There was an error connecting to Binance`,
                description: `We have informed the developers. Please try again later.`,
                key: "binance-connection-failed",
            });
        }
    };

    const onFinishFailed = (error) => {
        console.log(`Error`, error);
    };

    return (
        <div>
            <Drawer
                title={
                    <Title
                        level={4}
                        style={{
                            margin: 0,
                            color: Tokens.textPrimary,
                            fontWeight: 500,
                            fontSize: "18px",
                        }}
                    >
                        Connect Binance
                    </Title>
                }
                placement={isMobile ? "bottom" : "right"}
                push={false}
                width={isMobile ? "100%" : 460}
                height={isMobile ? "75%" : "100%"}
                closable
                closeIcon={
                    <CloseOutlined style={{ color: Tokens.textSecondary }} />
                }
                open={showConnectBinanceDrawer}
                onClose={() => onClose()}
                maskClosable
                maskStyle={{ backgroundColor: "rgba(0, 0, 0, 0.75)" }}
                headerStyle={{
                    backgroundColor: Tokens.bg,
                    borderBottom: `1px solid ${Tokens.hairline}`,
                }}
                bodyStyle={{
                    backgroundColor: Tokens.bg,
                    padding: "24px 16px",
                }}
                footerStyle={{
                    backgroundColor: Tokens.card,
                    borderTop: `1px solid ${Tokens.hairline}`,
                    padding: "12px 16px",
                }}
            >
                <div
                    style={{
                        maxWidth: Tokens.containerMaxWidth,
                        margin: "0 auto",
                        width: "100%",
                    }}
                >
                    <div
                        style={{
                            color: Tokens.textSecondary,
                            fontSize: "12px",
                            lineHeight: 1.5,
                            marginBottom: "16px",
                            padding: "10px 12px",
                            borderRadius: Tokens.radiusControl,
                            backgroundColor: Tokens.card,
                            border: `1px solid ${Tokens.hairline}`,
                        }}
                    >
                        Create a read-only API key in Binance API Management
                        (enable &quot;Enable Reading&quot; only — never enable
                        withdrawals or trading).
                    </div>
                    <Form
                        form={form}
                        layout="vertical"
                        onValuesChange={handleValueChange}
                        onFinish={onFinish}
                        onFinishFailed={onFinishFailed}
                        name="connectBinanceForm"
                        autoComplete="off"
                    >
                        <Form.Item
                            label={
                                <Text style={{ color: Tokens.textSecondary }}>
                                    API key
                                </Text>
                            }
                            name="apiKey"
                        >
                            <Input
                                type="text"
                                placeholder="Your read-only Binance API key"
                                style={{ fontFamily: Tokens.fontMono }}
                            />
                        </Form.Item>
                        <Form.Item
                            label={
                                <Text style={{ color: Tokens.textSecondary }}>
                                    API secret
                                </Text>
                            }
                            name="apiSecret"
                        >
                            <Input.Password
                                placeholder="Your Binance API secret"
                                style={{ fontFamily: Tokens.fontMono }}
                            />
                        </Form.Item>
                        <Form.Item>
                            <Button
                                disabled={disabled}
                                type="primary"
                                htmlType="submit"
                                block
                            >
                                Connect Binance
                            </Button>
                        </Form.Item>
                    </Form>
                </div>
            </Drawer>
        </div>
    );
};

export default AddBinance;
